export default __webpack_public_path__ + "static/media/loginbackground.e7dacb66.mp4";